import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { lightBlue } from "@mui/material/colors";

const propTypes = {
  children: PropTypes.object,
};

FormPaper.prototype = propTypes;

export default function FormPaper(props) {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "#a2bdc917",
        pb: 6,
        pt: 4,
      }}
    >
      <Grid container justifyContent="space-around">
        <Grid item xs={11}>
          {props.children}
        </Grid>
      </Grid>
    </Paper>
  );
}
